import React, { useCallback, useEffect, useRef, useState } from 'react';

const COPIED_TOOLTIP_DELAY = 500;

type CopyHandler = (event: React.MouseEvent<HTMLButtonElement>) => Promise<void>;

export const useCopyToClipboard = (value: string): [boolean, CopyHandler] => {
  const [isCopied, setIsCopied] = useState(false);
  const timeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(timeout.current), []);

  const copy = useCallback<CopyHandler>(
    async event => {
      event.stopPropagation();
      try {
        await navigator.clipboard.writeText(value);
        setIsCopied(true);
        timeout.current = setTimeout(() => setIsCopied(false), COPIED_TOOLTIP_DELAY);
      } catch {
        setIsCopied(false);
      }
    },
    [value],
  );

  return [isCopied, copy];
};
